import React from 'react';
import { MdOutlineAddShoppingCart } from "react-icons/md";

const Card = ({ imgSrc, imgAlt, title, description, reductionPrice, price, addCart, disabled, onClick }) => {
  return (
    <>
      <div className="card bg-gray-100 shadow-xl hover:cursor-pointer">
        <figure className="px-10 pt-3" onClick={onClick}>
          <img src={imgSrc} alt={imgAlt} className="rounded-xl w-32 sm:w-40 md:w-48" />
        </figure>
        <div className="flex-1 items-center text-center px-2 py-3" onClick={onClick}>
          <h2 className="md:text-xl uppercase poppins-bold text-pink-600 text-center">{title}</h2>
          <p className="text-gray-600 poppins-semibold text-center text-sm sm:text-base">{description}</p>
          <div className='flex justify-center items-center gap-x-2'>
            <p className="text-pink-600 poppins-semibold hover:text-pink-700 text-center text-sm sm:text-base md:text-lg">{price} MGA</p>
          </div>
        </div>
        <div className="flex flex-wrap items-start">
          <button className={`inline-flex items-center text-sm sm:text-base justify-center text-white poppins-semibold w-full py-2 rounded-b-xl ${disabled ? 'bg-pink-300 hover:bg-pink-300 cursor-not-allowed' : 'bg-pink-600 hover:bg-pink-700'}`} onClick={addCart} disabled={disabled}>
            <MdOutlineAddShoppingCart size={20} className='mr-1' /> <span className='flex min-[360px]:hidden min-[480px]:flex'>Ajouter au panier</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Card;
